/* WowStore giving round-up (2026-09-25).
 * One controller (window.WowGiving) keeps the donation lines in the cart consistent;
 * <wow-giving-roundup> elements are views (cart page = full, drawer = compact).
 * Donation lines: product "Round up for a cause", properties _giving = roundup | addon, _cause = cause name.
 * Round-up is always computed from the cart total WITHOUT any donation lines, so it never rounds up the round-up.
 * Fails closed: if the config is missing or the product is not available, nothing is shown.
 */
(function () {
  if (window.WowGiving) return;
  var cfgEl = document.getElementById('wow-giving-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var PREVIEW = !CFG.available && /[?&]giving_preview=1/.test(location.search);

  /* Free-delivery progress bar: donation lines never count toward the threshold (2026-09-25).
     The theme passes cart.items_subtotal_price to <free-ship-progress-bar>.init() from ~12 places;
     we subtract the donation cents we last saw and re-apply the exact goods subtotal after every sync. */
  var donationCents = 0;
  function patchBar() {
    var C = customElements.get('free-ship-progress-bar');
    if (!C || C.prototype.__wgPatched) return;
    var orig = C.prototype.init;
    C.prototype.init = function (subtotal) { return orig.call(this, Math.max(0, Number(subtotal || 0) - donationCents)); };
    C.prototype.__wgPatched = true;
  }
  if (window.customElements) { patchBar(); customElements.whenDefined('free-ship-progress-bar').then(patchBar); }
  function applyBar(cart) {
    donationCents = cart.items.filter(function (it) { return it.product_id === CFG.product_id || !!(it.properties && it.properties._giving); })
      .reduce(function (s, it) { return s + it.final_line_price; }, 0);
    document.querySelectorAll('free-ship-progress-bar').forEach(function (b) { try { b.init(cart.items_subtotal_price); } catch (e) {} });
  }

  if (!CFG.available && !PREVIEW) {
    // block off: still keep the bar honest if donation lines are somehow in the cart
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { if (c.items.some(function (it) { return it.product_id === CFG.product_id; })) applyBar(c); }).catch(function () {});
    return;
  }
  var FREE_T = (CFG.free_ship_thresholds || {})[CFG.country] || null; // cents; null = no free-delivery tier for this country

  var VAR = CFG.variants; // cents -> variant id
  var VAR_TO_CENTS = {};
  Object.keys(VAR).forEach(function (c) { VAR_TO_CENTS[String(VAR[c])] = parseInt(c, 10); });
  // Causes are data-driven (metaobject giving_cause): featured first, then earlier causes that stay selectable.
  var CAUSE_ROWS = (CFG.causes || []).map(function (c) { return typeof c === 'string' ? { name: c, status: 'featured', sort: 0 } : c; })
    .filter(function (c) { return c.name && (c.status === 'featured' || c.status === 'active'); })
    .sort(function (a, b) { return (a.status === b.status ? 0 : a.status === 'featured' ? -1 : 1) || (a.sort || 99) - (b.sort || 99); });
  var CAUSES = CAUSE_ROWS.map(function (c) { return c.name; });
  var FEATURED = CAUSE_ROWS.filter(function (c) { return c.status === 'featured'; }).map(function (c) { return c.name; });
  var ALSO = CAUSE_ROWS.filter(function (c) { return c.status === 'active'; }).map(function (c) { return c.name; });
  if (!CAUSES.length) return; // no causes configured -> fail closed
  var K_INTENT = 'wowGivingRoundup', K_CAUSE = 'wowGivingCause';

  function sget(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function sset(store, k, v) { try { v === null ? window[store].removeItem(k) : window[store].setItem(k, v); } catch (e) {} }
  function esc(t) { return String(t).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function money(c) { return '€' + (c / 100).toFixed(2); }

  var state = { cart: null, busy: false, fixes: 0, msg: '' };
  var views = new Set();

  function isDonation(it) { return it.product_id === CFG.product_id || !!(it.properties && it.properties._giving); }
  function analyse(cart) {
    var don = cart.items.filter(isDonation);
    var donTotal = don.reduce(function (s, it) { return s + it.final_line_price; }, 0);
    var base = Math.max(cart.total_price - donTotal, 0);
    var others = cart.items.length - don.length;
    var round = don.filter(function (it) { return (it.properties || {})._giving === 'roundup' || (VAR_TO_CENTS[String(it.variant_id)] || 100) < 100 && (it.properties || {})._giving !== 'addon'; });
    var addons = don.filter(function (it) { return round.indexOf(it) < 0; });
    var target = (100 - (base % 100)) % 100;
    return { don: don, donTotal: donTotal, base: base, others: others, round: round, addons: addons, target: target };
  }
  function cause() {
    var c = sget('localStorage', K_CAUSE);
    if (CAUSES.indexOf(c) >= 0) return c;
    var d = state.cart && state.cart.items.filter(function (it) { return isDonation(it) && CAUSES.indexOf((it.properties || {})._cause) >= 0; })[0];
    return d ? d.properties._cause : null; // only ever one of the three fixed names
  }
  function intent(a) {
    var v = sget('sessionStorage', K_INTENT);
    if (v === '1') return true;
    if (v === '0') return false;
    return a.round.length > 0; // fresh session: the cart is the truth
  }

  function api(path, body) {
    return fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'cart error'); return j; }); });
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function remove(key) { return api('/cart/change.js', { id: key, quantity: 0 }); }
  function add(cents, kind) {
    return api('/cart/add.js', { items: [{ id: VAR[String(cents)], quantity: 1, properties: { _giving: kind, _cause: cause() } }] });
  }
  function setProps(it) {
    var p = Object.assign({}, it.properties || {}, { _cause: cause() });
    return api('/cart/change.js', { id: it.key, quantity: it.quantity, properties: p });
  }

  /* Bring the cart in line with intent + cause. Returns true when it changed the cart. */
  function reconcile(cart) {
    var a = analyse(cart), jobs = [];
    var want = intent(a) && a.others > 0 && a.target > 0 && !!cause();
    // Free-delivery guard: donations must never lift the cart over the free-delivery threshold
    var addonSum = a.addons.reduce(function (s, it) { return s + it.final_line_price; }, 0);
    if (FREE_T && a.base < FREE_T && a.base + addonSum >= FREE_T && a.others > 0) {
      a.addons.forEach(function (it) { jobs.push(function () { return remove(it.key); }); });
      state.msg = 'Donations can\u2019t count towards free delivery, so we took off your ' + money(addonSum) + ' donation. You can add it again once your products reach ' + money(FREE_T).replace('.00', '') + '.';
      a.addons = []; addonSum = 0;
    }
    var crossRound = FREE_T && a.base < FREE_T && a.base + addonSum + a.target >= FREE_T;
    state.paused = !!(intent(a) && crossRound);
    if (crossRound) want = false;
    if (a.others === 0) { a.don.forEach(function (it) { jobs.push(function () { return remove(it.key); }); }); }
    else {
      var keep = null;
      a.round.forEach(function (it) {
        var ok = want && !keep && VAR_TO_CENTS[String(it.variant_id)] === a.target && it.quantity === 1 && (it.properties || {})._cause === cause();
        if (ok) keep = it; else jobs.push(function () { return remove(it.key); });
      });
      if (want && !keep) jobs.push(function () { return add(a.target, 'roundup'); });
      if (cause()) a.addons.forEach(function (it) { if ((it.properties || {})._cause !== cause()) jobs.push(function () { return setProps(it); }); });
    }
    if (!jobs.length) return Promise.resolve(false);
    if (PREVIEW) { state.msg = 'Preview only: the donation product is not active yet, so nothing was added.'; return Promise.resolve(false); }
    return jobs.reduce(function (p, j) { return p.then(j); }, Promise.resolve()).then(function () { return true; });
  }

  function refreshTheme(cart) {
    var jobs = [];
    var main = document.getElementById('main-cart-items');
    if (main && main.dataset.id) {
      jobs.push(fetch(location.pathname + '?sections=' + encodeURIComponent(main.dataset.id)).then(function (r) { return r.json(); }).then(function (sections) {
        if (typeof CartUtils !== 'undefined' && CartUtils.updateCartUI) {
          CartUtils.updateCartUI({ parsedState: { sections: sections, item_count: cart.item_count, total_price: cart.total_price, items_subtotal_price: cart.items_subtotal_price },
            sectionsToRender: [{ id: 'main-cart-items', section: main.dataset.id, selector: '.js-contents' }],
            cartInstance: document.querySelector('cart-items'), totalsSelector: '.cart-info .totals' });
          if (CartUtils.updateFreeShippingBar) CartUtils.updateFreeShippingBar(cart.items_subtotal_price);
        } else { location.reload(); }
      }));
    }
    var mini = document.getElementById('minicart-form');
    if (mini) {
      jobs.push(fetch('/?sections=minicart-form').then(function (r) { return r.json(); }).then(function (s) {
        var html = new DOMParser().parseFromString(s['minicart-form'] || '', 'text/html').querySelector('#minicart-form');
        if (html) mini.innerHTML = html.innerHTML;
      }));
    }
    if (typeof CartUtils !== 'undefined' && CartUtils.updateCartCount) {
      try { CartUtils.updateCartCount(cart.item_count); CartUtils.updateHeaderTotalPrice && CartUtils.updateHeaderTotalPrice(cart); } catch (e) {}
    }
    return Promise.all(jobs).catch(function () {});
  }

  function render() { views.forEach(function (v) { v.render(); }); }

  function sync(fromUser) {
    if (state.busy) { state.again = true; return Promise.resolve(); }
    state.busy = true; render();
    return getCart().then(function (cart) {
      state.cart = cart;
      if (Date.now() - (state.lastFix || 0) > 10000) state.fixes = 0;
      if (!fromUser && state.fixes > 4) return false; // loop guard
      return reconcile(cart).then(function (changed) {
        if (!changed) return false;
        state.fixes += fromUser ? 0 : 1; state.lastFix = Date.now();
        return getCart().then(function (c2) {
          // race guard: the cart may have been cleared/changed while we were adding -> never leave donations on their own
          var a2 = analyse(c2);
          if (a2.others === 0 && a2.don.length) {
            return a2.don.reduce(function (p, it) { return p.then(function () { return remove(it.key); }); }, Promise.resolve()).then(getCart);
          }
          return c2;
        }).then(function (c2) { state.cart = c2; return refreshTheme(c2).then(function () { return true; }); });
      });
    }).catch(function (e) {
      state.msg = 'Sorry, that did not work. Please try again.';
      if (window.console) console.warn('[giving]', e);
    }).then(function () {
      if (state.cart) applyBar(state.cart);
      state.busy = false; render();
      if (state.again) { state.again = false; return sync(false); }
    });
  }

  var api_ = {
    get state() { return state; }, FREE_T: FREE_T, CFG: CFG, PREVIEW: PREVIEW, analyse: analyse, cause: cause, intent: intent, money: money,
    setIntent: function (on) { state.msg = ''; sset('sessionStorage', K_INTENT, on ? '1' : '0'); state.fixes = 0; return sync(true); },
    setCause: function (c) { if (CAUSES.indexOf(c) < 0) return; state.msg = ''; sset('localStorage', K_CAUSE, c); state.fixes = 0; return sync(true); },
    addAmount: function (cents) {
      state.msg = '';
      if (!cause()) { state.msg = 'Choose a cause first.'; render(); return Promise.resolve(); }
      if (state.cart && FREE_T) {
        var a0 = analyse(state.cart);
        if (a0.base < FREE_T && a0.base + a0.donTotal + cents >= FREE_T) {
          state.msg = 'Donations can\u2019t count towards free delivery. Add ' + money(FREE_T - a0.base) + ' more in products first, or choose a smaller amount.'; render(); return Promise.resolve();
        }
      }
      if (PREVIEW) { state.msg = 'Preview only: the donation product is not active yet, so nothing was added.'; render(); return Promise.resolve(); }
      state.busy = true; render();
      return add(cents, 'addon').then(function () { state.busy = false; state.fixes = 0; return sync(true); })
        .catch(function () { state.busy = false; state.msg = 'Sorry, that did not work. Please try again.'; render(); });
    },
    removeDonations: function () {
      var a = state.cart ? analyse(state.cart) : null; if (!a) return;
      sset('sessionStorage', K_INTENT, '0');
      state.busy = true; render();
      a.don.reduce(function (p, it) { return p.then(function () { return remove(it.key); }); }, Promise.resolve())
        .then(function () { state.busy = false; return sync(true); })
        .catch(function () { state.busy = false; state.msg = 'Sorry, that did not work. Please try again.'; render(); });
    },
    register: function (v) { views.add(v); if (state.cart) v.render(); },
    unregister: function (v) { views.delete(v); },
    sync: sync
  };
  window.WowGiving = api_;

  /* Re-sync after ANY cart change made by the theme or other apps (quantity, remove, add-to-cart). */
  var t = null;
  function onCartTraffic(name) {
    if (!/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(name)) return;
    if (state.busy) return; // our own calls
    clearTimeout(t); t = setTimeout(function () { sync(false); }, 350);
  }
  try {
    new PerformanceObserver(function (list) { list.getEntries().forEach(function (e) { onCartTraffic(e.name); }); })
      .observe({ type: 'resource', buffered: false });
  } catch (e) {}

  class WowGivingRoundup extends HTMLElement {
    connectedCallback() {
      this.compact = this.getAttribute('data-variant') === 'compact';
      this.uid = 'wg' + Math.random().toString(36).slice(2, 8);
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      api_.register(this);
      if (!state.cart && !state.busy) sync(false); else this.render();
    }
    disconnectedCallback() { api_.unregister(this); }
    onChange(e) {
      var el = e.target;
      if (el.name === this.uid + '-cause') api_.setCause(el.value);
      else if (el.classList.contains('wg-round')) {
        if (el.checked && !cause()) { sset('sessionStorage', K_INTENT, '1'); state.msg = 'Now choose a cause for your round-up.'; render(); var f = this.querySelector('input[type=radio]'); f && f.focus(); return; }
        api_.setIntent(el.checked);
      }
    }
    onClick(e) {
      var b = e.target.closest('[data-wg-add]'); if (b) { e.preventDefault(); api_.addAmount(parseInt(b.getAttribute('data-wg-add'), 10)); return; }
      if (e.target.closest('[data-wg-clear]')) { e.preventDefault(); api_.removeDonations(); }
    }
    render() {
      var cart = state.cart;
      if (!cart) { this.hidden = true; return; }
      var a = analyse(cart);
      if (a.others === 0) { this.hidden = true; this.innerHTML = ''; return; }
      this.hidden = false;
      var on = intent(a), c = cause(), uid = this.uid;
      var roundedTo = a.base + a.target;
      var roundLabel = state.paused
        ? 'Round up <span class="wg-muted">(paused at this total: donations don\u2019t count towards free delivery)</span>'
        : a.target > 0
        ? 'Round up to ' + money(roundedTo) + ' <span class="wg-muted">(+' + money(a.target) + ')</span>'
        : 'Round up <span class="wg-muted">(your total is already a round euro)</span>';
      var chip = function (name) {
        return '<label class="wg-cause"><input type="radio" name="' + uid + '-cause" value="' + esc(name) + '"' + (c === name ? ' checked' : '') + (state.busy ? ' disabled' : '') + '><span>' + esc(name) + '</span></label>';
      };
      var causes = FEATURED.map(chip).join('') +
        (ALSO.length ? '<span class="wg-also">Also still supported:</span>' + ALSO.map(chip).join('') : '');
      var addBtns = this.compact ? '' : '<div class="wg-add" role="group" aria-label="Add a donation"><span class="wg-add__label">Or add</span>' +
        [100, 200, 500].map(function (x) { return '<button type="button" class="wg-chip" data-wg-add="' + x + '"' + (state.busy ? ' disabled' : '') + '>+' + money(x).replace('.00', '') + '</button>'; }).join('') + '</div>';
      var summary = a.donTotal > 0
        ? '<p class="wg-summary">Your donation: <strong>' + money(a.donTotal) + '</strong>' + (c ? ' to ' + esc(c) : '') + ' <button type="button" class="wg-link" data-wg-clear' + (state.busy ? ' disabled' : '') + '>Remove</button></p>' : '';
      var msg = state.msg ? '<p class="wg-msg" role="status">' + state.msg + '</p>' : '';
      var open = !this.compact || on || a.donTotal > 0 || !!state.msg; // drawer: causes appear once the box is ticked
      var note = this.compact
        ? '<p class="wg-note">100% passed on via PayPal Giving Fund. WowStore covers the fees. Not tax-deductible. <a href="/pages/round-up-for-a-cause">How it works</a></p>'
        : '<p class="wg-note">100% of your round-up or donation is passed on to the cause you choose via PayPal Giving Fund. WowStore covers the payment fees. Donations are not tax-deductible. <a href="/pages/round-up-for-a-cause">How it works</a></p>';
      this.innerHTML =
        '<fieldset class="wg' + (this.compact ? ' wg--compact' : '') + (state.busy ? ' wg--busy' : '') + '" aria-busy="' + (state.busy ? 'true' : 'false') + '">' +
        '<legend class="wg-title' + (this.compact ? ' wg-sr' : '') + '">Round up for a cause</legend>' +
        '<label class="wg-check"><input type="checkbox" class="wg-round"' + (on ? ' checked' : '') + (state.busy ? ' disabled' : '') + '>' +
        '<span>' + roundLabel + ' — the extra goes to a cause you choose</span></label>' +
        (open ? '<div class="wg-causes" role="radiogroup" aria-label="Choose a cause">' + causes + '</div>' : '') +
        addBtns + summary + msg + note +
        '</fieldset>';
    }
  }
  if (!customElements.get('wow-giving-roundup')) customElements.define('wow-giving-roundup', WowGivingRoundup);
})();
